import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  activitiesListRequest: ['params'],
  activitiesListSuccess: ['listData', 'page'],
  activitiesListFailure: ['listError'],
})

export const ActivityTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  listData: [],
  listFetching: null,
  listError: null,

  allLoaded: false
})

/* ------------- Reducers ------------- */

export const listRequest = (state) =>
  state.merge({ listFetching: true, listError: null })

export const listSuccess = (state, { listData, page }) => {
  if (page > 1) {
    return state.merge({
      listFetching: false, listData: state.listData.concat(listData),
      allLoaded: listData.length < 1
    })
  }
  return state.merge({ listFetching: false, listData })
}

export const listFailure = (state, { listError }) =>
  state.merge({ listFetching: false, listError })

export const reset = (state) => state.merge(INITIAL_STATE)

/* ------------- Selectors ------------- */

export const ActivitySelectors = {
  activitiesList: state => state.activities.listData
}

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.ACTIVITIES_LIST_REQUEST]: listRequest,
  [Types.ACTIVITIES_LIST_SUCCESS]: listSuccess,
  [Types.ACTIVITIES_LIST_FAILURE]: listFailure,
})



// WEBPACK FOOTER //
// ./src/Redux/ActivityRedux.js